import { styled, Theme } from '@mui/material';

export const sxStyles = {
  accordionDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  infoText: (theme: Theme) => ({
    color: theme.palette.grey['500'],
  }),
  alert: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'start',
    maxWidth: '100%',
    color: theme.palette.info.main,
  }),
  uploadButton: {
    display: 'flex',
    gap: '0.5rem',
    maxWidth: '92px',
  },
};

export const StyledList = styled('ul')(() => ({
  paddingLeft: '1.5rem',
}));

export const StyledListItem = styled('li')(({ theme }) => ({
  color: theme.palette.grey['500'],
}));
